import SiteInertiaController from '@/actions/App/Http/Controllers/SiteInertiaController';
import { Button } from '@/components/ui/button';
import { Typo } from '@/components/ui/typography';
import { Link } from '@inertiajs/react';
import { ShoppingCart } from 'lucide-react';

interface CartEmptyStateProps {
  /**
   * Custom heading text to display
   * @default "Giỏ hàng trống"
   */
  heading?: string;

  /**
   * Custom description text to display
   * @default "Bạn chưa có dịch vụ nào trong giỏ hàng. Hãy khám phá và thêm dịch vụ yêu thích của bạn."
   */
  description?: string;

  /**
   * Text for the CTA button
   * @default "Khám phá dịch vụ"
   */
  buttonText?: string;

  /**
   * URL to navigate when CTA button is clicked
   * @default "/search"
   */
  buttonHref?: string;

  /**
   * Additional CSS classes for the container
   */
  className?: string;
}

/**
 * CartEmptyState component displays an empty cart state with icon, message and CTA button
 *
 * @param props - Configuration options for the empty state
 * @returns JSX element displaying empty cart state
 */
export function CartEmptyState({
  heading = 'Giỏ hàng trống',
  description = 'Bạn chưa có dịch vụ nào trong giỏ hàng. Hãy khám phá và thêm dịch vụ yêu thích của bạn.',
  buttonText = 'Khám phá dịch vụ',
  buttonHref = SiteInertiaController.search().url,
  className = '',
}: CartEmptyStateProps) {
  return (
    <div className={`mx-auto flex min-h-[50vh] max-w-md flex-col items-center justify-center text-center ${className}`}>
      <ShoppingCart className="mx-auto mb-6 h-24 w-24 text-gray-300" />
      <Typo variant="h3" className="mb-4 font-bold text-gray-900">
        {heading}
      </Typo>
      <Typo variant="muted" className="mb-8">
        {description}
      </Typo>
      <Button asChild size="lg" className="rounded-full">
        <Link href={buttonHref}>{buttonText}</Link>
      </Button>
    </div>
  );
}
